(function () {
  const slideshow = (root = document) => {
    const sections = root.matches?.(".slideshow-section")
      ? [root]
      : root.querySelectorAll(".slideshow-section");
    sections.forEach(function (section) {
      const slider = section.querySelector(".slideshow__swiper");
      const box = section.querySelector(".slideshow");
      if (!slider || !box || slider.swiper || typeof Swiper === "undefined") return;
      const autoplay = box.dataset.autoplay === "true";
      const stopAutoplay = box.dataset.stopAutoplay === "true";
      const delay = Number(box.dataset.delay) * 1000;
      const autoplayParm = autoplay ? {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        } : {};
      const swiperParms = {
        parallax: box.dataset.parallax === "true",
        speed: Number(box.dataset.speed) * 1000,
        effect: box.dataset.effect,
        loop: true,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,
        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        navigation: {
          nextEl: section.querySelector(".swiper-button-next"),
          prevEl: section.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: section.querySelector(".swiper-pagination"),
          clickable: true,
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(slider, swiperParms);
      section.classList.add("slider_started");
      colorScheme(swiper);
      swiper.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = activeSlide?.querySelector(".slideshow-slide")?.dataset.colorScheme;
        changeItems.forEach((item) => {
          if (!item?.classList) return;
          item.classList.remove("color-background-1", "color-background-4");
          if (colorScheme) item.classList.add(colorScheme);
        });
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => slideshow(), { once: true });
  } else {
    slideshow();
  }

  document.addEventListener("shopify:section:load", (event) => slideshow(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll(".slideshow__swiper").forEach((slider) => {
      slider.swiper?.destroy(true, true);
    });
  });
})();
